import React from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import NativeSelect from "@mui/material/NativeSelect";
import CreateIcon from "@mui/icons-material/Create";
import InputAdornment from "@mui/material/InputAdornment";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import PhonelinkSetupIcon from "@mui/icons-material/PhonelinkSetup";
import EditLocationAltIcon from "@mui/icons-material/EditLocationAlt";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import Typography from "@mui/material/Typography";

import GAMECATEGORY from "../register_page/game_category";
// import { toast } from "react-toastify";
import usePlayerData from "../../hooks/usePlayerData";

function PlayerEditForm({ editItem, setEditItem, setOpenEditDialog }) {
  const { updatePlayerData } = usePlayerData();

  const closeEditDialog = () => {
    setOpenEditDialog(false);
  };

  // Helper to format ISO date strings (e.g., 1999-10-24T18:15:00.000Z) to YYYY-MM-DD
  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    return dateString.split("T")[0];
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    // if (editItem.phone_number?.length !== 10) {
    //   toast.error(`Contact must be 10 digits`, {
    //     position: "top-right",
    //     autoClose: 2000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "light",
    //   });
    //   return;
    // }
    updatePlayerData(editItem, closeEditDialog);
  };
  const handleEditChange = (e) => {
    setEditItem({ ...editItem, [e.target.name]: e.target.value });
  };
  const todayStr = new Date().toISOString().split("T")[0];
  return (
    <form onSubmit={handleEditSubmit}>
      <Box
        display="flex"
        flexDirection="column"
        gap="1rem"
        justifyContent="center"
      >
        <Typography
          sx={{
            color: "#000000",
            fontFamily: "Roboto, serif",
            fontWeight: "550",
            textAlign: "center",
          }}
        >
          Update Player Detail
        </Typography>

        {/* GAME CATEGORY */}
        <FormControl fullWidth variant="standard">
          <InputLabel htmlFor="game-event-native">Game Category</InputLabel>
          <NativeSelect
            value={editItem?.game_event || ""}
            inputProps={{
              name: "game_event",
              id: "game-event-native",
            }}
            onChange={handleEditChange}
          >
            {GAMECATEGORY.map((gameCat, index) => (
              <option key={index} value={gameCat}>
                {gameCat}
              </option>
            ))}
          </NativeSelect>
        </FormControl>

        {/* DATE OF BIRTH */}
        <TextField
          id="dob"
          label="Date of Birth"
          type="date"
          name="dob"
          variant="standard"
          value={formatDateForInput(editItem?.dob)}
          onChange={handleEditChange}
          inputProps={{ max: todayStr }}
          InputLabelProps={{ shrink: true }}
          
          required
        />

        {/* NAME */}
        <TextField
          id="standard-basic-name"
          label="Name"
          name="name"
          variant="standard"
          value={editItem?.name || ""}
          onChange={handleEditChange}
          InputLabelProps={{ shrink: true }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <ManageAccountsIcon />
              </InputAdornment>
            ),
          }}
          required
        />

        {/* CLUB/DISTRICT */}
        <TextField
          id="standard-basic-club"
          label="Club/District"
          name="club"
          variant="standard"
          value={editItem?.club || ""}
          onChange={handleEditChange}
          InputLabelProps={{ shrink: true }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <EditLocationAltIcon />
              </InputAdornment>
            ),
          }}
        />

        {/* POINTS */}
        <TextField
          id="standard-basic-point"
          label="Points"
          type="number"
          variant="standard"
          name="point"
          value={editItem?.point ?? ""}
          onChange={handleEditChange}
          InputLabelProps={{ shrink: true }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <StarBorderIcon />
              </InputAdornment>
            ),
          }}
        />

        {/* CONTACT */}
        <TextField
          id="standard-number-phone"
          type="tel"
          label="Contact"
          variant="standard"
          name="phone_number"
          value={editItem?.phone_number || ""}
          onChange={handleEditChange}
          InputLabelProps={{ shrink: true }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <PhonelinkSetupIcon />
              </InputAdornment>
            ),
          }}
          
        />

        {/* SUBMIT BUTTON */}
        <Button
          type="submit"
          variant="contained"
          style={{
            width: "100px",
            alignSelf: "center",
            backgroundColor: "#022362",
          }}
          endIcon={<CreateIcon />}
        >
          Edit
        </Button>
      </Box>
    </form>
  );
}

export default PlayerEditForm;